import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '@redux/store';

import Api from 'Api/Api';
import { url } from '@api-config';
import { ILogSummaryItem } from '../constants/ingestionLog.interface';

export const ingestionLogsKeys = {
  all: ['ingestionLogs'],
};

export const useFetchIngestionLogs = () => {
  const searchTerm = useAppSelector((state) => state.ingestion.logFiltering.searchTerm);
  const statusId = useAppSelector((state) => state.ingestion.logFiltering.statusId);

  const queryResult = useQuery<ILogSummaryItem[], Error>({
    queryKey: ingestionLogsKeys.all,
    queryFn: () => Api.get(url.ingestionSummary),
    staleTime: Infinity,
    select: (data) => {
      if (!searchTerm && statusId == null) return data; // Return all logs if no filters are applied

      const text = (searchTerm ?? '').toString().toLowerCase().trim();

      const filteredLogs = data
        .filter((log) => {
          if (!text) return true;
          const name = (log?.dataSourceName ?? '').toString().toLowerCase();
          const type = (log?.ingestionType ?? '').toString().toLowerCase();

          return name.includes(text) || type.includes(text);
        })
        .filter((log) => (statusId == null ? true : log?.status === statusId));

      return filteredLogs;
    },
    placeholderData: [],
  });

  return {
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,

    data: queryResult.data,
    fetchLogs: queryResult.refetch,
  };
};
